import { render } from "./ButtonDropdown.vue?vue&type=template&id=4d8cfa5e&scoped=true"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js"

import "./ButtonDropdown.vue?vue&type=style&index=0&id=4d8cfa5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8cfa5e"]])

export default __exports__